import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {ProcessoService} from "../../../services/processo-service";
import {NovoProcesso} from "../../../models/novo-processo";
import {ListaAtendimento} from "../../../../cadastro/models/lista-atendimento";
import {AtendimentoService} from "../../../../cadastro/services/atendimento.service";
import {ListaSolicitante} from "../../../../cadastro/models/lista-solicitante";
import {PessoaService} from "../../../../cadastro/services/pessoa.service";
import Swal from "sweetalert2";
import {Observable, of} from "rxjs";
import {PastaService} from "../../../services/pasta-service";
import {Pasta} from "../../../models/pasta";
import {NovaPessoa} from "../../../../cadastro/models/nova-pessoa";
import {NovoAtendimento} from "../../../../cadastro/models/novo-atendimento";
import { NovoComponent as AtendimentoNovoComponent } from "../../../../cadastro/atendimento/novo/novo.component";
import { NovaPastaComponent } from "../../../componentes/nova-pasta/nova-pasta.component";
import { NovoTipoAcaoComponent } from "../../../../cadastro/gerais/tipo-acao/novo-tipo-acao.component";
import {NovaPasta} from "../../../models/nova-pasta";
import {TipoAcao} from "../../../../cadastro/gerais/models/tipo-acao";
import {CadastrosGeraisService} from "../../../../cadastro/services/cadastros-gerais.service";
import {AngularEditorConfig} from "@kolkov/angular-editor";

@Component({
    selector: 'app-novo-processo',
    templateUrl: './novo.component.html',
    styleUrl: './novo.component.css',
    standalone: false
})
export class NovoComponent {
  @ViewChild(AtendimentoNovoComponent) modalAtendimentoComp: AtendimentoNovoComponent;
  @ViewChild(NovaPastaComponent) modalPastaComp: NovaPastaComponent;
  @ViewChild(NovoTipoAcaoComponent) modalTipoAcaoComp: NovoTipoAcaoComponent;
  @Input() isModal = false;
  @Output() atualizarLista = new EventEmitter();
  modalNovoProcesso = false;
  loading = true;
  formCadastrar: FormGroup;
  showBotaoAtendimento = false;
  showBotaoPasta = false;
  cliente = new NovaPessoa();
  atendimento = new NovoAtendimento();
  processo = new NovoProcesso();
  atendimentos = new ListaAtendimento();
  clientes = new ListaSolicitante();
  pastas: Pasta[] = [];
  itensAtendimentos: Observable<Array<{id: number, descricao: string}>>;
  itensSolicitantes: Observable<Array<{id: number, descricao: string}>>;
  itensPasta: Observable<Array<{id: number, descricao: string}>>;
  showModalAtendimento = false;
  showModalCliente = false;
  listaTipoAcao: TipoAcao[] = [];

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '200px',
    placeholder: 'Digite a descrição aqui...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(private formBuilder: FormBuilder,
              private pessoaService: PessoaService,
              private pastaService: PastaService,
              private router: Router,
              private toastr: ToastrService,
              private processoService: ProcessoService,
              private geraisService: CadastrosGeraisService,
              private atendimentoService: AtendimentoService) {
    this.construirFormulario();
    this.listarClientes();
    this.listarTipoAcao();
    this.loading = false;

  }

  voltar(){
    if (this.isModal) {
      this.fecharModal();
    } else {
      this.router.navigateByUrl('/juridico/processo');
    }
  }

  salvar(){
    this.validarFormulario();
    this.preencherModelo();
    if(this.formCadastrar.invalid){
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.loading = true;

        this.processoService.adicionar(this.processo).subscribe(
          (response) => {
            this.loading = false;
            if (response.sucesso) {
              this.toastr.success("Processo salvo com sucesso");
              if (this.isModal) {
                this.fecharModal();
                this.atualizarLista.emit();
              } else {
                this.router.navigateByUrl('/juridico/processo');
              }
            } else {
              this.toastr.error("Erro ao salvar processo - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            this.loading = false;
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        );
      }
    });
  }

  buscarAtendimento(){
    let id = this.formCadastrar.controls['solicitante'].value;
    if (!id) return;
    this.listarAtendimento(id);
    this.listarPastas(id);
    this.showBotaoAtendimento = true;
    this.showBotaoPasta = true;
    this.formCadastrar.controls['atendimento'].enable();
    this.formCadastrar.controls['pasta'].enable();
    this.gerarTitulo();
  }

  modalPasta(){
    this.modalPastaComp.showModal(this.formCadastrar.controls['solicitante'].value);
  }

  modalTipoAcao(){
    this.modalTipoAcaoComp.showModal();
  }


  modalCliente(){
    this.showModalCliente = true;
  }

  salvarModalCliente(){
    this.pessoaService.adicionar(this.cliente).subscribe(response =>{
      if(response.sucesso){
        this.listarClientes();
      }
      else{
        this.toastr.error("Erro ao salvar a pasta: " + response.errors[0].mensagem);
      }
      this.fecharModalCliente();
    }, error => {
      this.toastr.error("Erro ao salvar a pasta");
      this.fecharModalCliente();
    });
  }

  modalAtendimento(){
    this.modalAtendimentoComp.showModalNovoAtendimento(this.formCadastrar.controls['solicitante'].value);
  }

  showModalNovoProcesso(){
    this.modalNovoProcesso = true;
    this.loading = false;
  }

  fecharModal(){
    this.showModalCliente = false;
    this.modalNovoProcesso = false;
  }

  fecharModalCliente(){
    this.showModalCliente = false;
  }

  gerarTitulo(){
    let solicitante = this.clientes.itens.find(x => x.id == this.formCadastrar.controls['solicitante'].value)?.nome;
    let envolvido = this.formCadastrar.controls['nomeOutraParte'].value;
    this.formCadastrar.controls['titulo'].setValue(solicitante +' x ' + envolvido);
  }

  public listarTipoAcao(){
    this.geraisService.selecionarListaTipoAcoes().subscribe( response =>{
      if(response.sucesso){
        this.listaTipoAcao = response.dados;
      }
    })
  }

  private validarFormulario(){
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private preencherModelo(){
    this.processo.atendimento = this.formCadastrar.controls['atendimento'].value;
    this.processo.nomeOutraParte = this.formCadastrar.controls['nomeOutraParte'].value;
    this.processo.titulo = this.formCadastrar.controls['titulo'].value;
    this.processo.tipoAcao = this.formCadastrar.controls['tipoAcao'].value;
    this.processo.pasta = this.formCadastrar.controls['pasta'].value;
    this.processo.descricao = this.formCadastrar.controls['descricao'].value;
    this.processo.solicitante = this.formCadastrar.controls['solicitante'].value;
  }

  private construirFormulario(): void {
    this.formCadastrar = this.formBuilder.group({
      nomeOutraParte: ['', Validators.required],
      atendimento: ['', Validators.required],
      titulo: ['', Validators.required],
      tipoAcao: ['', Validators.required],
      pasta: ['', Validators.required],
      descricao: ['', Validators.required],
      solicitante: ['', Validators.required]
    });
    this.formCadastrar.controls['atendimento']?.disable();
    this.formCadastrar.controls['pasta']?.disable();
    this.listarClientes();
  }

  public listarClientes(){
    this.pessoaService.selecionarListaAtivos().subscribe(response => {
      if(response.sucesso){
        let lista: any[] = [];
        this.clientes = response.dados;
        for(let contador = 0; contador < response.dados.itens.length; contador++){
          let id = response.dados.itens[contador]?.id;
          let descricao = response.dados.itens[contador]?.nome;
          lista.push({id: id, descricao: descricao});
        }
        this.itensSolicitantes = this.getItens(lista);
      }
    }, error => {
      this.toastr.error('Erro ao listar solicitantes ' + error, 'Erro');
    });
  }

  listarPastas(pessoaId: number){
    if (!pessoaId) return;
    this.pastaService.buscarPorPessoaId(pessoaId).subscribe(response => {
      if(response.sucesso){
        let lista: any[] = [];
        this.pastas = response.dados;
        for(let contador = 0; contador < response.dados.length; contador++){
          let id = response.dados[contador]?.id;
          let descricao = response.dados[contador]?.descricao;
          lista.push({id: id, descricao: descricao})
        }
        this.itensPasta = this.getItens(lista);
        this.formCadastrar.controls['pasta'].enable();
      }
    }, error => {
      this.formCadastrar.controls['pasta'].disable();
    });
  }

  private getItens(lista: any[]): Observable<Array<{id: number, descricao: string}>> {
    return of(lista).pipe();
  }

  private listarAtendimento(pessoaId: number){
    this.atendimentoService.selecionarPorPessoaId(pessoaId).subscribe(response =>{
      let lista: any[] = [];
      if(response.sucesso){
        this.atendimentos = response.dados;
        for(let contador = 0; contador < response.dados.itens.length; contador++){
          let id = response.dados.itens[contador]?.id;
          let descricao = response.dados.itens[contador]?.descricaoResumida;
          lista.push({id: id, descricao: descricao})
        }
        this.formCadastrar.controls['atendimento'].enable();
        this.itensAtendimentos = this.getItens(lista);
      }
    }, error => {
      this.formCadastrar.controls['atendimento'].disable();
    });
  }
}
